import template from './device-diagnostics.component.html';

const EVENT_TRACKING_NAME = 'assetDetailDiagnostic';
const EVENT_TRACKING_ACTIONS = {
  moreDeviceDetails: 'moreDeviceDetails',
};

class AssetDeviceController {
  constructor(deviceDiagnosticService) {
    'ngInject';
    this.deviceDiagnosticService = deviceDiagnosticService;
    this._cellSignal = undefined;
  }

  $onInit() {
    this.getCellSignalInfo();
    this.init = true;
  }

  $onChanges(changes) {
    const { refreshing } = changes;
    if (refreshing && refreshing.currentValue === true && this.init) {
      this.getCellSignalInfo();
    }
  }

  $onDestroy() {}

  getCellSignalInfo() {
    if (this.asset && this.asset.esn) {
      this.deviceDiagnosticService
        .getLastReportedCellSignalSeries(this.asset.esn)
        .then(data => {
          this._cellSignal = data;
        })
        .catch(() => {
          this._cellSignal = { status: this.deviceDiagnosticService.signalStatus.Error };
        });
    }
  }

  addToDataLayer(data) {
    window.dataLayer.push({
      event: EVENT_TRACKING_NAME,
      data: { ...data },
    });
  }

  clickedMoreDetailsBtn() {
    this.addToDataLayer({
      action: EVENT_TRACKING_ACTIONS.moreDeviceDetails,
    });
  }

  get packagesText() {
    const { packages = [] } = this.asset || {};
    const basePackages = packages.filter(p => !p.isModule);
    const modulePackages = packages.filter(p => p.isModule);
    //to make sure base package come first.
    return [...basePackages, ...modulePackages].map(p => p.name).join(', ');
  }

  get deviceAttrs() {
    const { device = {} } = this.asset || {};
    const { firmware_ver, config_ver } = device.attrs || {};
    return {
      firmwareVer: firmware_ver,
      configVer: config_ver,
    };
  }

  get gpsSignal() {
    const { locationSeries } = this.asset || {};
    return this.deviceDiagnosticService.getGpsStatusInfo(locationSeries);
  }


  get cellSignal() {
    return this._cellSignal;
  }
}

export default {
  template,
  controller: AssetDeviceController,
  //not using vm as when using ui-route it is conflicting with parent vm
  //https://github.com/johnpapa/angular-styleguide/issues/577#issue-115275989
  controllerAs: 'deviceVm',
  bindings: {
    refreshing: '<',
    asset: '<',
  },
};
